import React, { useState } from 'react';
import api from '../services/api';
import toast from 'react-hot-toast';

const DeliveryNotification = ({ postalCode, onClose }) => {
  const [city, setCity] = useState('');
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!city.trim() || !email.trim()) {
      toast.error('Veuillez remplir tous les champs');
      return;
    }

    // Validation email simple
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.error('Veuillez entrer un email valide');
      return;
    }

    setLoading(true);

    try {
      await api.post('/notifications/delivery-interest', {
        postalCode,
        city,
        email,
        source: window.location.pathname
      });

      setSubmitted(true);
      toast.success('Merci ! Nous vous contacterons dès que votre ville sera desservie.');
      
      // Fermer automatiquement après 5 secondes
      setTimeout(() => {
        if (onClose) onClose();
      }, 5000);

    } catch (error) {
      console.error('Erreur:', error);
      toast.error('Une erreur est survenue. Veuillez réessayer.');
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="bg-white rounded-xl p-6 shadow-lg border border-green-200 animate-fade-in mt-3">
        <div className="flex items-center gap-3 mb-4">
          <svg className="w-8 h-8 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <h3 className="text-lg font-bold text-green-600">Inscription enregistrée !</h3>
        </div>
        <p className="text-gray-600">
          Nous vous contacterons dès que {city} sera disponible dans notre zone de livraison.
        </p>
        <button
          onClick={onClose}
          className="mt-4 text-sm text-secondary hover:underline"
        >
          Fermer
        </button>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl p-6 shadow-lg border border-gray-200 animate-fade-in mt-3">
      <div className="flex justify-between items-start mb-4">
        <h3 className="text-lg font-bold text-primary">Votre ville n'est pas encore desservie</h3>
        <button
          onClick={onClose}
          className="text-gray-400 hover:text-gray-600 transition"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
      
      <p className="text-gray-600 text-sm mb-4">
        Nous sommes en train d'étendre notre périmètre de livraison. Nous revenons vers vous dès que votre ville devient éligible.
      </p>

      <form onSubmit={handleSubmit} className="space-y-3">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Nom de la ville
          </label>
          <input
            type="text"
            placeholder="Ex : Colmar"
            value={city}
            onChange={(e) => setCity(e.target.value)}
            className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:outline-none focus:border-secondary transition"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Adresse email
          </label>
          <input
            type="email"
            placeholder="Ex : vous@email.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:outline-none focus:border-secondary transition"
            required
          />
        </div>

        <button
          type="submit"
          disabled={loading}
          className="w-full bg-primary text-white py-2.5 rounded-lg font-semibold hover:bg-opacity-90 transition disabled:opacity-50"
        >
          {loading ? 'Envoi en cours...' : 'Être informé'}
        </button>

        <p className="text-xs text-gray-400 text-center">
          En soumettant, vous acceptez d'être contacté lorsque la livraison sera disponible dans votre ville.
        </p>
      </form>
    </div>
  );
};

export default DeliveryNotification;